import { connect } from 'react-redux'
import React from 'react'
import { Table, Thead, Th, Tr, Td } from 'components/reactable'

import NoResults from '../noResults'
import styles from './clientTarifications.scss'
import {fetchClientTarifications, setOpenedSubmenu, fetchClientTarification, setAppModule,
    setClientSubModule} from 'state/actions'
import nesProp from 'nested-property'

import i18n from 'lib/i18n'
import { getTheLanguageCodeByAnyLanguageOnAnyLanguage } from 'lib/helpers'
import ClientTarificationsZoom from './clientTarificationsZoom'
import CreateTarification from './clientTarificationCreate'

import MifidButton from '../DSDocuments/mifidButton'
import {DS_MODULE_CLIENT_TARIFICATION} from 'state/constants'
import moment from 'moment'
import * as c from 'state/constants'

const _= i18n('clientTarification')

/**
 * This method can render the table for tarification overview
 * @param {*} props
 * @returns
 */
const Results = (props) => {
    let {data, zoomTo, /* setState, */ canCreateTarification, canCreateMifid, clientId, dispatch,
        refreshTarifications, moduleOptions} = props
    const topPaginationElem = []

    /* if(canCreateTarification) {
        topPaginationElem.push(
            <input type='button'
                key={'createTarificationModalOpenerButtonKey'}
                onClick={() => {
                    setState({createTarificationModalIsOpen: true})
                }}
                className={styles.buttonGreen}
                value={_('request')}
            />
        )
    } */

    if(canCreateTarification) {
        topPaginationElem.push(
            <MifidButton
                moduleKeyToSet={DS_MODULE_CLIENT_TARIFICATION}
                clientId={clientId}
                callBackOnClose={(clientId, tarificationId)=>{
                    refreshTarifications(clientId)
                    .then(() => {
                        dispatch(setAppModule(c.CLIENTS, clientId))
                        dispatch(setOpenedSubmenu(tarificationId, {}))
                        dispatch(setClientSubModule('tarification'))
                    })
                }}
                buttonText={_('request')}
                customModalTitle1={_('tarificationWizardStep1Title')}
                customModalTitle2={_('tarificationWizardStep2Title')}
                customModalTitle3={_('tarificationWizardStep3Title')}
                customModalDescriptionStep1={_('tarificationWizardStep1Description')}
                customModalDescriptionStep2={_('tarificationWizardStep2Description')}
                customModalDescriptionStep3={_('tarificationWizardStep3Description')}
                moduleOptions={moduleOptions}
            />
        )
    }

    let tableData = data || []

    return (
        <div key={"tarificationTableContainerDiv"}>
            <Table
                itemsPerPage={10}
                filterable={[
                    'tarificationNumber',
                    'group',
                    'descriptionRisico',
                    'tarificationState',
                    'requestDate'
                ]}
                sortable={[
                    {column: 'requestDate', sortFunction: 'Date'},
                    'tarificationNumber',
                    'mainGroup',
                    'descriptionRisico',
                    'tarificationState'
                ]}
                topPaginationElemR={
                    topPaginationElem
                }
                defaultSort={{
                    //column: 'sentDate',
                    column: 'requestDate',
                    sortFunction: 'Date',
                    direction: 'desc',
                }}
            >
                <Thead key={"tHeadOfTarifListKey"}>
                    <Th column='tarificationNumber' key={"tarificationNumberKey"}>
                        <strong>{_('tarificationNumber')}</strong>
                    </Th>

                    <Th column='mainGroup' key={"mainGroupKey"}>
                        <strong>{_('mainGroup')}</strong>
                    </Th>

                    <Th column='descriptionRisico' key={"descriptionRisicoKey"}>
                        <strong>{_('descriptionRisico')}</strong>
                    </Th>
                    <Th column='requestDate' key={"requestDateKey"}>
                        <strong>{_('requestDate')}</strong>
                    </Th>

                    <Th column='tarificationState' key={"tarificationStateKey"}>
                        <strong>{_('tarificationState')}</strong>
                    </Th>
                </Thead>
                {tableData && tableData.map((item, key) => {
                    const tarificationMain = item.tarificationMain
                    return (<Tr className='centered clickable'
                    key={key} onClick={() => zoomTo(tarificationMain.tarificationId)}
                    >
                        <Td column="tarificationNumber">{tarificationMain.tarificationNumber}</Td>
                        <Td column="mainGroup">{tarificationMain.mainGroup}</Td>
                        <Td column="descriptionRisico">{tarificationMain.descriptionRisico}</Td>
                        <Td column="requestDate" value={moment(tarificationMain.requestDate)}>{moment(tarificationMain.requestDate).format('DD-MM-YYYY')}</Td>
                        <Td column="tarificationState">{tarificationMain.tarificationState}</Td>
                    </Tr>)
                }
                )}

            </Table>
            { (!tableData || tableData.length === 0) &&
                <NoResults type="clientTarification" />
            }
        </div>
    )
}

@connect(state => {
    const clientId = state.app.opened
    const clientData = state.clients.clientData? state.clients.clientData[clientId] : null
    const tarifications = state.clients.tarifications[clientId] ? state.clients.tarifications[clientId] : null
    const tarificationId = state.app.submenuOpened
    const tarification = state.client.tarificationDetail
    const subModuleZoom = nesProp.get(state, 'clients.subModuleZoom.tarificationNumber')
    const clientAccess = nesProp.get(state, "app.security.actions")
    let canCreateMifid = false
    let canCreateTarification = false

    clientAccess.map((item, key) => {
        if (item.actionName == 'createmifid') {
            canCreateMifid = ((item.actionAllowed === "true") || (item.actionAllowed === true)) ? true : false
        }

        if (item.actionName == 'createTarification') {
            canCreateTarification = ((item.actionAllowed === "true") || (item.actionAllowed === true)) ? true : false
        }
    })

    return {
        tarification,
        tarifications,
        canCreateTarification,
        tarificationId,
        clientId,
        clientData,
        canCreateMifid,
        subModuleZoom,
        clientOptionsDict: state.client.clientOptionsDict
    }

})

/**
 * Tarification overview module
 */
export default class ClientTarifications extends React.Component {

    constructor(props) {
        super(props)
        this.state = {initializationCompleted: false, tarificationsLoaded: false, createTarificationModalIsOpen: false, tarificationDetailLoaded: false}
    }

    componentWillMount() {
        const {clientId} = this.props
        this.refreshTarifications(clientId)
    }

    /**
     * This function will refresh the list of tarifications in store and return with a promise
     * @param {*} clientId
     * @returns Promise
     */
    refreshTarifications(clientId) {
        const {dispatch} = this.props

        return new Promise((resolve, reject) => {
            // load tarifications
            this.setState({tarificationsLoaded: false}, () => {
                dispatch(fetchClientTarifications(clientId))
                .then(() => {
                    this.setState({tarificationsLoaded: true}, ()=> {resolve()})
                })
                .catch(() => {
                    this.setState({tarificationsLoaded: true}, ()=> {resolve()})
                })
            })
        })
    }

    /**
     * Triggered before update the module.
     * @param {object} nextProps
     * @param {object} nextState
     */
    componentWillUpdate(nextProps, nextState) {
        const {dispatch, clientId, tarificationId} = this.props
        const {tarificationDetailLoaded} = this.state

        // on clear opened tarification we must reload tarification list
        if ((!nextProps.tarificationId && tarificationId)) {
            this.setState({tarificationsLoaded: false}, () => {
                dispatch(fetchClientTarifications(clientId))
                .then(() => {
                    this.setState({tarificationsLoaded: true})
                })
                .catch(() => {
                    this.setState({tarificationsLoaded: true})
                })
            })
        }

        if ((!tarificationDetailLoaded && tarificationId) || (nextProps.tarificationId  && nextProps.tarificationId !== tarificationId)) {
            return dispatch(fetchClientTarification(nextProps.tarificationId ))
               .then(() => this.setState({tarificationDetailLoaded: true}))
        }

        this.navigateToTarificationFromSearch()
    }

    /**
     * This function vill zoom to tarifican if client search is made by tarification number
     */
    navigateToTarificationFromSearch(){
        const {subModuleZoom, tarifications} = this.props
        const {tarificationDetailLoaded} = this.state

        if(!tarificationDetailLoaded && subModuleZoom && tarifications){
            const openedTarificationFromSearc = tarifications.find(tarification => {
                return tarification.tarificationMain.tarificationNumber.includes(subModuleZoom)
            })
            if(openedTarificationFromSearc) {
                this.zoomTo(openedTarificationFromSearc.tarificationMain.tarificationId)
            }
        }
    }

    /**
     * Used to get and open tarification details
     * @param {string} tarificationId
     * @returns
     */
    zoomTo(tarificationId) {
       this.getTarification(tarificationId)
    }

    getTarification(tarificationId) {
        const {dispatch} = this.props
        return dispatch(fetchClientTarification(tarificationId))
            .then(() => {
                return this.setState({tarificationDetailLoaded: true}, () =>{
                    dispatch(setOpenedSubmenu(tarificationId))
                })
            })
    }

    /**
    * This function return with values for email sender, collected from this module
    * depending on the current data structure.
    */
    collectVariableValues() {
        const { clientData, clientId, tarification, tarificationId } = this.props
        const { clientOptionsDict } = this.state

        let tarificationBrokerNumber = nesProp.get(tarification, "brokerNumber")
        let emails = nesProp.get(clientData, "detail.emails")
        let clientName = nesProp.get(clientData, "main.name")

        // process email list to be digestible for email sender
        emails = emails.map((item) => ({
            referenceId: clientId,
            label: clientName,
            value: item.email,
            default: (item.default == "true" || item.default == true) ? true : false
        }))

        emails = emails.sort((item, item2) => {
            if (item.default && !item2.default) { return -1 }
            if (!item.default && item2.default) { return 1 }
            if ((item.default && item2.default) || (!item.default && !item2.default)) { return 0 }
        }) || []

        // decode language of client from a word to a code. Ex. "Nederlands" to "nl"
        let clientLanguage = nesProp.get(clientData, "detail.language") || ''
        clientLanguage = getTheLanguageCodeByAnyLanguageOnAnyLanguage(clientLanguage, clientOptionsDict)

        return {
            tarificationNumber: nesProp.get(this.props, 'tarification.tarificationNumber'),

            clientDocuments: nesProp.get(clientData, "clientDocuments"),
            clientDocumentsType: 'client',
            clientDocumentsId: clientId,

            tarificationDocuments: nesProp.get(this.props, "tarification.tarificationDocuments"),
            tarificationDocumentsType: "tarification",
            tarificationDocumentsId: tarificationId,

            clientId: false,
            contractId: false,
            claimId: false,
            tarificationId,
            clientName: clientName,
            clientNumber: nesProp.get(clientData, "main.clientNumber"),
            clientLanguage,
            clientEmails: emails,

            brokerNumber: tarificationBrokerNumber,

            tarificationDetail: tarification,
            clientData: nesProp.get(clientData, "main")
        }
    }

    render() {
        const {tarifications, tarification, tarificationId, canCreateTarification, clientData, clientId, canCreateMifid, dispatch} = this.props
        const {createTarificationModalIsOpen, createContractState} = this.state
        let selectedTarificationDetails = null

        if(tarifications && tarificationId){
            for( let t of tarifications){
                if(t.tarificationMain.tarificationId === tarificationId){
                    selectedTarificationDetails = tarification
                }
            }
        }

        return (
            <div>
                <div className={styles.moduleSection}>
                    {!selectedTarificationDetails?
                        <Results
                            {...this.props}
                            canCreateTarification={canCreateTarification}
                            data={tarifications || []}
                            zoomTo={(tarification) => {this.zoomTo(tarification)}}
                            setState={(paramForSetState)=>(this.setState(paramForSetState))}
                            canCreateMifid={canCreateMifid}
                            clientId={clientId}
                            refreshTarifications={(clientId) => this.refreshTarifications(clientId) }
                            moduleOptions={this.collectVariableValues()}
                        />
                        :
                        <div className={styles.clientTarificationsZoomContainer}>
                            <ClientTarificationsZoom
                                tarification={selectedTarificationDetails}
                                clientData={clientData}
                                clientId={clientId}
                                tarificationId={String(tarificationId)}
                                createContractState={createContractState}
                                dispatch={dispatch}
                                _translationFromOverview={_}
                                canCreateTarification={canCreateTarification}
                            />
                        </div>
                    }
                </div>


                <CreateTarification
                    modalIsOpen={createTarificationModalIsOpen}
                    tarification={{
                        tarificationId: '',
                        tarificationNumber: '',
                        error: '0',
                        errorString: 'This is the error string'
                    }}
                    clientId = {clientId}
                    closeModal={()=>(this.setState({createTarificationModalIsOpen: false}))}
                    tarificationId={tarificationId}
                    policyHolder={nesProp.get(clientData, "main.name") || ""}
                />
            </div>
        )
    }

}



// WEBPACK FOOTER //
// ./components/clients/clientTarifications.jsx